import React from "react";
import { InputAdornment } from "@material-ui/core";
import SrInput from "../SrInput";

const filterKeys = (e, onKeyDown) => {
  const charCode = e.which ? e.which : e.keyCode;
  const blockedKeyCodes = [69, 187, 189];

  if (blockedKeyCodes.includes(charCode)) {
    e.stopPropagation();
    e.preventDefault();
  }

  if (onKeyDown) {
    onKeyDown(e);
  }
};

const SrCurrencyInput = ({ value, onKeyDown, ...props }) => (
  <SrInput
    InputProps={{
      startAdornment: <InputAdornment position="start">$</InputAdornment>,
    }}
    onKeyDown={(e) => filterKeys(e, onKeyDown)}
    type="number"
    value={value}
    {...props}
  />
);

export default SrCurrencyInput;
